import React from 'react';

import MenuItem from 'material-ui/MenuItem';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import CourseActions from '../../actions/CourseActionCreator';
import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';
import { formatName } from '../../utils/StringUtils';

const url = '/dashboard/course/enrolments';

const CourseEnrolmentForm = React.createClass({

    getInitialState: function () {

        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            details: {
                id: '',
                userId: '',
                courseCode: '',
                courseId: '',
                courseName: '',
                courseType: '',
                title: '',
                firstName: '',
                lastName: '',
                hash: '',
                method: '',
                progress: '',
                score: '',
                requirement: '',
                status: '',
                sysStatus: '',
                isMandatory: null
            },
            dropdowns: {
                statusOptions: ['waiting', 'enrolled', 'completed', 'cancelled'],
            },
        }
    },

    componentDidMount: function() {
        CourseEnrolmentStore.addChangeListener(this.onChange);
        if(this.state.isEdit) {
            CourseActions.getEnrolment(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        CourseEnrolmentStore.removeChangeListener(this.onChange);
    },

    render: function () {

        const formTitle = (this.state.isEdit  ? this.state.details.courseName : 'New enrolment');
        const redirectTo = (this.state.isEdit ? `/dashboard/course/enrolment/${this.state.details.id}` : url);

        const fullName = formatName(this.state.details);

        return(

            <Form
                title={formTitle}
                onSave={this.onSave}
                onCancel={this.onCancel}
                redirectTo={redirectTo}
            >
                <h2>{fullName}</h2>

                <SelectField
                    name="status"
                    value={this.state.details.status}
                    floatingLabelText="Status"
                    hintText="Status"
                    required
                >
                    {this.state.dropdowns.statusOptions.map(function(status) {
                        return (
                            <MenuItem
                                key={status}
                                value={status}
                                primaryText={status}
                            />
                        )
                    })}
                </SelectField>
                <TextField
                    name="progress"
                    value={this.state.details.progress}
                    validations="isNumeric"
                    validationError="Please use only numbers"
                    hintText="Progress"
                    floatingLabelText="Progress"
                />

                <TextField
                    name="score"
                    value={this.state.details.score}
                    validations="isNumeric"
                    validationError="Please use only numbers"
                    hintText="Score"
                    floatingLabelText="Score"
                />
                <Checkbox
                    name="isMandatory"
                    value={this.state.details.isMandatory}
                    label="Mandatory"
                />
                <TextField
                    name="event"
                    value={this.state.details.progress}
                    validations="isNumeric"
                    validationError="Please use only numbers"
                    hintText="Event"
                    floatingLabelText="Event"
                />
            </Form>
      );
    },

    onCancel: function() {
        document.location.href = (this.state.isEdit ? `/dashboard/course/enrolment/${this.state.details.id}` : url);
    },

    onSave: function (model) {
        if (this.state.isEdit){
            return CourseActions.updateEnrolment(this.state.details.courseId, this.props.routeParams.id, model);
        } else {
            return CourseActions.saveEnrolment(model);
        }
    },

    onChange: function() {
        const enrolment = CourseEnrolmentStore.getById(this.props.routeParams.id);
        if (enrolment !== undefined) {
            this.setState({ details: enrolment });
        }
    }
});

export default CourseEnrolmentForm;
